import React, { createContext, useCallback, useState } from 'react'
import PropTypes from 'prop-types'

const NotebookContext = createContext({})

const USE_FACING_PAGES_STORAGE_KEY = 'notes.facing_pages'
const initialUseFacingPages = (window.localStorage.getItem(USE_FACING_PAGES_STORAGE_KEY) ?? 'true') === 'true'

export const NotebookContextProvider = ({ children }) => {
   const [useFacingPages, setUseFacingPages] = useState(initialUseFacingPages)
   const [visibleNoteIds, setVisibleNoteIds] = useState([])
   const [currentNotebook, setCurrentNotebook] = useState(null)

   const setAndPersistFacingPages = useCallback((value) => {
      setUseFacingPages(value)
      window.localStorage.setItem(USE_FACING_PAGES_STORAGE_KEY, String(value))
   }, [])

   const contextValue = {
      currentNotebook,
      useFacingPages,
      visibleNoteIds,
      setCurrentNotebook,
      setVisibleNoteIds,
      setUseFacingPages: setAndPersistFacingPages
   }

   return (
      <NotebookContext.Provider value={contextValue}>
         {children}
      </NotebookContext.Provider>
   )
}

NotebookContextProvider.propTypes = {
   children: PropTypes.node.isRequired
}

export default NotebookContext
